module.exports = __webpack_public_path__ + "static/media/ESN_SGGW_black.74868164.png";